// Radha — Contracts data, straight from PostgREST. Third module, same template.
//
// Copy of useDisputesDirect with the table names and columns changed. RLS
// (migration 019) scopes the tenant; no tenant id appears in any query here.
import { useQuery } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export type ContractStatus = "draft" | "active" | "expired" | "terminated" | "renewed";
export type RenewalStatus = "upcoming" | "in_progress" | "won" | "lost" | "auto_renewed";

export interface Contract {
  id: string;
  contract_number: string;
  customer_name: string;
  customer_gstin: string | null;
  acv_amount: string;
  invoiced_amount: string;
  headroom: string;
  start_date: string;
  end_date: string;
  status: ContractStatus;
  auto_renew: boolean;
}

export interface Renewal {
  id: string;
  contract_id: string;
  renewal_date: string;
  status: RenewalStatus;
  churn_probability: string;
  proposed_acv: string | null;
  notes: string | null;
}

export const contractsKeys = {
  contracts: ["contracts-direct", "contracts"] as const,
  renewals: ["contracts-direct", "renewals"] as const,
};

export function useContracts() {
  return useQuery({
    queryKey: contractsKeys.contracts,
    queryFn: async (): Promise<Contract[]> => {
      const { data, error } = await supabase
        .from("contracts")
        .select(
          "id, contract_number, customer_name, customer_gstin, acv_amount, " +
            "invoiced_amount, headroom, start_date, end_date, status, auto_renew",
        )
        .order("acv_amount", { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as unknown as Contract[];
    },
    staleTime: 30_000,
  });
}

export function useRenewals() {
  return useQuery({
    queryKey: contractsKeys.renewals,
    queryFn: async (): Promise<Renewal[]> => {
      const { data, error } = await supabase
        .from("renewals")
        .select(
          "id, contract_id, renewal_date, status, churn_probability, " +
            "proposed_acv, notes",
        )
        .order("renewal_date", { ascending: true })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as unknown as Renewal[];
    },
    staleTime: 30_000,
  });
}
